import { MONTHS, getMonthLabel } from "../utils/MonthsUtils"
import { Button } from "../../design_system/components/Button/Button.jsx"
import { SelectBox } from "../../design_system/components/Input Fields/SelectBox.jsx"
import { currentMonth, currentYear, generateYears } from "../utils/dateUtils"
import { createLayerId, pushLayer, popLayer, getLayerZIndex } from "../../design_system/components/Popup/popupStack"
import React, { useState, useEffect, useRef, useMemo } from "react"
import ReactDOM from "react-dom"

export const DateFilter = ({
    selectedDate,
    setSelectedDate,
    handleOnClose,
    handleOnFilterSave,
    curr_rel_id,
    usePortal = false,
    triggerRef = null,
    ...props
}) => {
    const { fromMonth, fromYear, toMonth, toYear } = selectedDate
    const getMonthOptions = (year) => {
        const months = (year === currentYear) ? MONTHS.filter(month => month.value <= currentMonth) : MONTHS
        return months.map(m => ({ label: getMonthLabel(m.value, "short"), value: m.value }))
    }

    const fromYearOptions = useMemo(() =>
        generateYears(50).map(y => ({ label: String(y), value: y })),
        []
    )
    const toYearOptions = useMemo(() =>
        generateYears(currentYear - fromYear).map(y => ({ label: String(y), value: y })),
        [fromYear]
    )
    const fromMonthOptions = useMemo(() => getMonthOptions(fromYear), [fromYear])
    const toMonthOptions = useMemo(() => getMonthOptions(toYear), [toYear])

    const layerIdRef = useRef(createLayerId())
    const [zIndex, setZIndex] = useState(null)
    const [rect, setRect] = useState(null)
    useEffect(() => {
        if (usePortal && triggerRef?.current) {
            setRect(triggerRef.current.getBoundingClientRect())
        }

        // Participate in popup stack for correct z-index
        pushLayer(layerIdRef.current)
        setZIndex(getLayerZIndex(layerIdRef.current))

        return () => {
            popLayer(layerIdRef.current)
        }
    }, [usePortal, triggerRef])

    const content = (
        <div className="date-filter__dropdown" style={usePortal && rect ? {
            position: "fixed",
            top: rect.bottom + 8,
            right: window.innerWidth - rect.right,
            zIndex: zIndex || 1100,
        } : {}}>
            <div className="flex items-center date-filter__row">
                <div className="date-filter__year">
                    <div className="body-s-semibold">From</div>
                    <SelectBox
                        Size="Small"
                        placeholder="Year"
                        value={fromYear || ""}
                        options={fromYearOptions}
                        handleOnChange={(val) => setSelectedDate({ ...selectedDate, fromYear: val })}
                        menuCustomStyle={{ maxHeight: 200, overflowY: 'auto' }}
                    />
                </div>
                <div className="date-filter__month">
                    <SelectBox
                        Size="Small"
                        placeholder="Month"
                        value={fromMonth || ""}
                        options={fromMonthOptions}
                        handleOnChange={(val) => setSelectedDate({ ...selectedDate, fromMonth: val })}
                        menuCustomStyle={{ maxHeight: 200, overflowY: 'auto' }}
                    />
                </div>
            </div>
            <div className="flex items-center date-filter__row">
                <div className="date-filter__year">
                    <div className="body-s-semibold">To</div>
                    <SelectBox
                        Size="Small"
                        placeholder="Year"
                        value={toYear || ""}
                        options={toYearOptions}
                        handleOnChange={(val) => setSelectedDate({ ...selectedDate, toYear: val })}
                        menuCustomStyle={{ maxHeight: 200, overflowY: 'auto' }}
                    />
                </div>
                <div className="date-filter__month">
                    <SelectBox
                        Size="Small"
                        placeholder="Month"
                        value={toMonth || ""}
                        options={toMonthOptions}
                        handleOnChange={(val) => setSelectedDate({ ...selectedDate, toMonth: val })}
                        menuCustomStyle={{ maxHeight: 200, overflowY: 'auto' }}
                    />
                </div>
            </div>
            <div className="date-filter__save">
                <Button Size="Small" buttonStyle={{ width: 'max-content' }} innerButtonStyle={{ padding: 'var(--space-s) var(--space-xl)' }}
                    onClick={() => handleOnFilterSave(curr_rel_id)}>Save</Button>
            </div>
        </div>
    )

    return (
        <>
        <div style={{ position: 'fixed', inset: 0, zIndex: 998 }} onClick={handleOnClose} />
        {usePortal && rect ? ReactDOM.createPortal(content, document.body) : content}
        </>
    )
}
